import { useState } from 'react'
import { Box, Drawer, List, ListItem, IconButton } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'

import { isMobileView } from 'lib/GlobalConstants'

//P.S. modify the logic when the list updates
const MobileDrawer = ({ drawerProps }: any) => {
  const [visibility, setVisibility] = useState(false)
  const list = () => (
    <Box role="presentation">
      <List>
        {drawerProps.map((drawerProp: any, index: any) => (
          <ListItem disablePadding key={index}>
            {drawerProp.component}
          </ListItem>
        ))}
      </List>
    </Box>
  )

  return (
    <div>
      <>
        {isMobileView ? (
          <IconButton
            onClick={() => setVisibility(true)}
            data-testid="share-reporting-details"
          >
            <MoreVertIcon />
          </IconButton>
        ) : null}
        <Drawer
          anchor="bottom"
          open={visibility}
          onClose={() => setVisibility(false)}
        >
          {list()}
        </Drawer>
      </>
    </div>
  )
}

export default MobileDrawer
